<template>
    <div class="main-content bg-white">
        <div class="page-header">
            <h3 class="page-title">Профиль</h3>
        </div>
        <div class="row">
            <div class="col-sm-6 col-md-5 col-lg-3">
                <b-form>
                    <input type="password" style="display:none;" readonly>
                    <b-form-group label="ФИО"
                                  label-for="name">
                        <!--<b-form-input id="name"-->
                        <!--oninvalid="this.setCustomValidity('Введите ФИО')"-->
                        <!--required-->
                        <!--type="text"-->
                        <!--v-model="user.name">-->
                        <!--</b-form-input>-->
                        <b-form-input id="name"
                                      size="sm"
                                      type="text"
                                      v-model="user.name">
                        </b-form-input>
                        <span class=" alert-danger"
                              v-if="submitted && !user.name">Поле ФИО является обязательным.</span>
                    </b-form-group>
                    <b-form-group label="Email"
                                  label-for="email">
                        <b-form-input id="email"
                                      size="sm"
                                      pattern="[a-z0-9._%+-]+@zorka.mobi$"
                                      type="email"
                                      v-model="user.email">
                        </b-form-input>
                        <!--<b-form-input id="email"-->
                        <!--size="sm"-->
                        <!--pattern="[a-z0-9._%+-]+@zorka.mobi$"-->
                        <!--required-->
                        <!--type="email"-->
                        <!--v-model="user.email">-->
                        <!--</b-form-input>-->
                        <span class=" alert-danger"
                              v-if="submitted && !user.email">Поле Email является обязательным.</span>
                        <span class=" alert-danger" v-if="submitted && message">{{message}}</span>
                    </b-form-group>
                    <div class="row">
                        <div class="col-sm-6">
                            <b-form-group label="Network ID"
                                          label-for="network_partner_id">
                                <b-form-input id="network_partner_id"
                                              size="sm"
                                              type="number"
                                              v-model="user.network_partner_id">
                                </b-form-input>
                            </b-form-group>
                        </div>
                        <div class="col-sm-6">
                            <b-form-group label="Market ID"
                                          label-for="market_partner_id">
                                <b-form-input id="market_partner_id"
                                              size="sm"
                                              autocomplete="new-password"
                                              type="number"
                                              v-model="user.market_partner_id">
                                </b-form-input>
                            </b-form-group>
                        </div>
                    </div>
                    <b-form-group label="Текущий пароль"
                                  label-for="currentPassword">
                        <b-form-input id="currentPassword"
                                      size="sm"
                                      readonly
                                      autocomplete="off"
                                      type="password"
                                      onfocus="this.removeAttribute('readonly');"
                                      v-on:blur="checkCurrentPassword()"
                                      onblur="this.setAttribute('readonly','');"
                                      v-model="currentPassword">
                        </b-form-input>
                        <span class=" alert-danger"
                              v-if="currentPasswordMessage">{{currentPasswordMessage}}</span>
                    </b-form-group>
                    <b-form-group label="Новый пароль"
                                  label-for="newPassword">
                        <b-form-input id="newPassword"
                                      size="sm"
                                      readonly
                                      onfocus="this.removeAttribute('readonly');"
                                      onblur="this.setAttribute('readonly','');"
                                      v-on:blur="validateNewPassword()"
                                      autocomplete="off"
                                      type="password"
                                      v-model="newPassword">
                        </b-form-input>
                        <span class=" alert-danger"
                              v-if="newPasswordMessage">{{newPasswordMessage}}</span>
                    </b-form-group>
                    <b-form-group label="Подтверждение пароля"
                                  label-for="passwordRepeat">
                        <b-form-input id="passwordRepeat"
                                      size="sm"
                                      readonly
                                      onfocus="this.removeAttribute('readonly');"
                                      onblur="this.setAttribute('readonly','');"
                                      v-on:blur="validateRepeatPassword()"
                                      autocomplete="off"
                                      type="password"
                                      v-model="passwordRepeat">
                        </b-form-input>
                        <span class=" alert-danger"
                              v-if="repeatPasswordMessage">{{repeatPasswordMessage}}</span>
                    </b-form-group>
                    <b-button size="sm"
                              type="submit"
                              v-on:click="onSubmit"
                              variant="primary">
                        Сохранить
                    </b-button>
                    <div class="form-errors"></div>
                </b-form>
            </div>
        </div>
    </div>
</template>
<script>
    import UsersService from '../../services/usersDataService'

    export default {
        name: 'profile',
        components: {
            UsersService: UsersService
        },
        data() {
            return {
                user: {
                    name: this.$currentUser.name,
                    email: this.$currentUser.email,
                    network_partner_id: this.$currentUser.network_partner_id,
                    market_partner_id: this.$currentUser.market_partner_id,
                    password: null,
                    newPassword: null
                },
                currentPassword: null,
                newPassword: null,
                passwordRepeat: null,
                currentPasswordMessage: null,
                newPasswordMessage: null,
                repeatPasswordMessage: null,
                submitted: false,
                message: null,
                isCurrentPasswordIncorrect: false,
                isNewPasswordIncorrect: false,
                isRepeatPasswordIncorrect: false
            }
        },
        methods: {
            checkCurrentPassword() {
                this.isCurrentPasswordIncorrect = false

                if (this.newPassword && this.passwordRepeat && !this.currentPassword) {
                    this.currentPasswordMessage = 'Введите текущий пароль.';
                    this.isCurrentPasswordIncorrect = true

                    return
                }
                if (this.currentPassword && this.currentPassword != '') {
                    UsersService.checkCurrentPassword(this.currentPassword)
                        .then(function (response) {
                            if (response.passwordCheck === false) {
                                this.isCurrentPasswordIncorrect = true
                                this.currentPasswordMessage = 'Текущий пароль введен неверно.';
                            } else {
                                this.isCurrentPasswordIncorrect = false
                                this.currentPasswordMessage = null
                            }
                        }.bind(this))
                }
            },
            onSubmit(evt) {
                evt.preventDefault();

                this.submitted = true;
                if (!this.user.name || !this.user.email) {
                    evt.preventDefault();

                    return;
                }

                if (!this.newPassword && !this.passwordRepeat && !this.currentPassword) {
                    this.currentPasswordMessage = null
                    this.newPasswordMessage = null
                    this.repeatPasswordMessage = null
                }

                if (this.isCurrentPasswordIncorrect || this.isNewPasswordIncorrect || this.isRepeatPasswordIncorrect) {
                    evt.preventDefault();

                    return;
                }

                this.user.password = this.currentPassword
                this.user.newPassword = this.newPassword

                UsersService.updateCurrentUser(this.user)
                    .then(function (response) {
                        this.currentPasswordMessage = null
                        this.newPasswordMessage = null
                        this.repeatPasswordMessage = null

                        if (response.error) {
                            switch (response.error) {
                                case 'email exists':
                                    this.message = 'Данный Email используется другим пользователем.';
                                    break;
                                case 'invalid email':
                                    this.message = 'Некорректный Email.';
                                    break;
                                case 'incorrect domain':
                                    this.message = 'Email обязан принадлежать почтовому домену @zorka.mobi.';
                                    break;
                                case 'incorrect password':
                                    this.currentPasswordMessage = 'Текущий пароль введен неверно.';
                                    break;
                                default:
                                    this.message = 'Произошла ошибка.';
                                    break;
                            }
                        } else {
                            window.location.href = '/profile';
                        }
                    }.bind(this))
            },
            validateNewPassword() {
                this.isNewPasswordIncorrect = false

                if (this.newPassword && this.newPassword.length < 6) {
                    this.newPasswordMessage = 'Пароль должен содержать не менее 6-ти знаков.';
                    this.isNewPasswordIncorrect = true
                }

                if (this.currentPassword && !this.newPassword || this.passwordRepeat && !this.newPassword) {
                    this.newPasswordMessage = 'Введите новый пароль.';
                    this.isNewPasswordIncorrect = true
                }
                if (this.newPassword && this.newPassword.length >= 6) {
                    this.newPasswordMessage = null;
                }
            },
            validateRepeatPassword() {
                this.isRepeatPasswordIncorrect = false
                if (this.newPassword && !this.passwordRepeat) {
                    this.repeatPasswordMessage = 'Введите подтверждение нового пароля.';
                    this.isRepeatPasswordIncorrect = true
                }

                if (this.newPassword && this.passwordRepeat && this.newPassword !== this.passwordRepeat) {
                    this.repeatPasswordMessage = 'Не совпадает с новым паролем.';
                    this.isRepeatPasswordIncorrect = true
                }

                if (this.newPassword && this.passwordRepeat && this.newPassword === this.passwordRepeat) {
                    this.repeatPasswordMessage = null;
                }
            },
        },
        beforeMount() {
            this.user = {
                name: this.$currentUser.name,
                email: this.$currentUser.email,
                network_partner_id: this.$currentUser.network_partner_id,
                market_partner_id: this.$currentUser.market_partner_id
            }
        },
    }
</script>
<style>

</style>



// WEBPACK FOOTER //
// resources/js/views/front/Profile.vue